import { render, staticRenderFns } from "./CardsAgainstHumanity.vue?vue&type=template&id=303fa0f6&"
import script from "./CardsAgainstHumanity.vue?vue&type=script&lang=js&"
export * from "./CardsAgainstHumanity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports